import React from 'react';
import './Website.css';

const PrivacyPolicy = () => {
  return (
    <main className="site-page legal-page">
      <article className="section-inner legal-card">
        <h1>
          Unsubscriber's Privacy Policy
        </h1>
        <p>
          At <strong>Unsubscriber</strong>, your privacy is our priority. This Privacy Policy
          outlines the types of data we collect, how we use it, and how we protect your
          information. By using our service, you agree to the practices described in this policy.
        </p>

        <h2>1. Data We Collect</h2>
        <p>
          When you use Unsubscriber, we may collect the following types of information:
        </p>
        <ul>
          <li>
            <strong>Personal Information:</strong> Such as your email address when you authorize
            our extension to access your inbox.
          </li>
          <li>
            <strong>Email Metadata:</strong> Including sender email addresses, subject lines, and
            unsubscribe links for the purpose of managing subscriptions.
          </li>
          <li>
            <strong>Usage Data:</strong> Information about how you use the extension, such as the
            number of scans performed and actions taken.
          </li>
        </ul>

        <h2>2. How We Use Your Data</h2>
        <p>
          We use the data we collect to provide and improve our service, including:
        </p>
        <ul>
          <li>Identifying and processing unsubscribe requests.</li>
          <li>Deleting cluttered or unwanted emails based on your preferences.</li>
          <li>Improving the functionality and user experience of the extension.</li>
          <li>Providing customer support and troubleshooting issues.</li>
        </ul>

        <h2>3. Data Sharing</h2>
        <p>
          We do not sell, rent, or share your personal information with third parties, except in
          the following cases:
        </p>
        <ul>
          <li>With your explicit consent.</li>
          <li>
            To comply with legal obligations, such as responding to lawful requests from public
            authorities.
          </li>
          <li>To protect our rights and ensure the safety of our users.</li>
        </ul>

        <h2>4. Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your data from unauthorized
          access, disclosure, alteration, or destruction. This includes encryption of sensitive
          data and restricted access to our systems.
        </p>

        <h2>5. Data Retention</h2>
        <p>
          We retain your data only as long as necessary to provide our services or comply with
          legal requirements. If you cancel your subscription or stop using our extension, we
          delete your data within a reasonable time.
        </p>

        <h2>6. Your Rights</h2>
        <p>
          You have the following rights regarding your data:
        </p>
        <ul>
          <li>
            <strong>Access:</strong> You can request a copy of the data we have collected about
            you.
          </li>
          <li>
            <strong>Deletion:</strong> You can request that we delete your personal data.
          </li>
          <li>
            <strong>Correction:</strong> You can request corrections to inaccurate or incomplete
            data.
          </li>
        </ul>

        <h2>7. Third-Party Services</h2>
        <p>
          Our extension may include links to third-party websites or services. We are not
          responsible for the privacy practices or content of these third parties. Please review
          their privacy policies before interacting with their services.
        </p>

        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of significant
          changes by updating the date at the bottom of this page. Continued use of the extension
          constitutes acceptance of the revised policy.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions, concerns, or requests regarding this Privacy Policy, please
          contact us at <strong>donotreplyeon@gmail.com</strong>.
        </p>

        <footer>
          <p>&copy; {new Date().getFullYear()} Unsubscriber. All rights reserved.</p>
        </footer>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
